"use strict";

exports.__esModule = true;
exports.PortalContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PortalContext = exports.PortalContext = /*#__PURE__*/_react["default"].createContext([]);